import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { JsonInterceptor } from './json-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: JsonInterceptor, multi: true }];
